import React from 'react'

const About = () => {
  return (
    <div className="hero min-h-screen bg-base-100">
        <div className="hero-content text-center">
            <div className="max-w-3xl">
              <h1 className="text-2xl md:text-4xl leading-snug mb-4">Control your finance, Own your data, embrace your community</h1>
              <p className='text-xs md:text-xl mb-8'>An ecosystem around decentralized identity to control your <br />money, data and communities at one convenient place.</p>
              <button className="btn bg-black px-12 rounded-full text-white hover:bg-primary">Download</button>
            </div>
        </div>
    </div>
  )
}

export default About